import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type SettleManagerInfo =
  | {
      isSettleTarget: false;
    }
  | {
      isSettleTarget: true;
      managerName?: string;
      managerPhoneNumber: string;
      managerEmail: string;
      managerEmail2?: string;
      managerEmail3?: string;
    };

export const getSettleManagerInfo = (settleId: string) => {
  return api<PcApiResponse<SettleManagerInfo>>('get', `/pc-api/v1/${PREFIX_PATH}/settle/base-info`, { settleId });
};
